import React, {
  createContext,
  startTransition,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type AccountSheetContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const AccountSheetContext = createContext<AccountSheetContextValue | null>(null);

export const AccountSheetProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(
    () => startTransition(() => setIsOpen(true)),
    [],
  );
  const close = useCallback(
    () => startTransition(() => setIsOpen(false)),
    [],
  );
  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);
  return (
    <AccountSheetContext.Provider value={value}>
      {children}
    </AccountSheetContext.Provider>
  );
};

export function useAccountSheet(): AccountSheetContextValue {
  const ctx = useContext(AccountSheetContext);
  if (!ctx) {
    throw new Error('useAccountSheet must be used within AccountSheetProvider');
  }
  return ctx;
}
